import { render } from "./a-room.vue?vue&type=template&id=3499ba14&scoped=true&bindings={\"room_key\":\"props\",\"password\":\"setup\",\"messages\":\"setup\",\"retrieveMessages\":\"setup\"}"
import script from "./a-room.vue?vue&type=script&lang=js"
export * from "./a-room.vue?vue&type=script&lang=js"

import "./a-room.vue?vue&type=style&index=0&id=3499ba14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3499ba14"

export default script